module.exports = __webpack_public_path__ + "img/t5-16.ec3057e1.svg";